module.exports = __webpack_public_path__ + "img/1x.997621c.jpg";